import React, { Component } from 'react';

import { Container, Typography, Box } from '@mui/material';
// import moment from 'moment';
import moment from 'moment';
import { withSnackbar } from 'notistack';
import { withTranslation } from 'react-i18next';
import ReactPlaceholder from 'react-placeholder';
import 'react-placeholder/lib/reactPlaceholder.css';
import { connect } from 'react-redux';
import { Breadcrumbs } from 'wae_rwlb_reactlibrary';

import { getDeliveryTableData, getAllDeliveryData } from '../../../actions';
import { Table } from '../../../components';
import { breadcrumbNameMap } from '../../../helpers/config';
import DeliveryPlaceholder from '../DeliveryPlaceholder';
import { styles } from './styles';

const columnsConfig = t => [
  {
    field: 'col1',
    headerName: t('deliveryScreenTranslations:ID'),
    key: 'OutboundDelivery',
    minWidth: 150,
    flex: 1,
    inputType: 'TextField',
  },
  {
    field: 'col4',
    headerName: t('deliveryScreenTranslations:DELIVERY'),
    key: 'DeliveryDate',
    minWidth: 150,
    flex: 1,
    inputType: 'Date',
    valueFormatter: params => {
      return params.value ? moment(params.value).format('MMMM DD, YYYY') : '-';
    },
  },
];
class Delivery extends Component {
  constructor(props) {
    super(props);
    this.state = {
      page: 0,
      rowsPerPage: 20,
      filteredData: [],
      searchTerm: '',
      filterField: '',
      selectedDate: new Date(),
      showDateFilter: false,
      isLoading: false,
    };
  }

  async componentDidMount() {
    try {
      const { page, rowsPerPage } = this.state;
      const skip = page;
      const top = rowsPerPage;
      await this.props.getDeliveryTableData(skip, top, this.props.enqueueSnackbar);
    } catch (err) {
      console.log(err);
    }
  }

  handleChange = async (e, value) => {
    try {
      const { rowsPerPage, searchTerm, showDateFilter, filterField } = this.state;
      const { t } = this.props;
      const skip = value * rowsPerPage;
      this.setState({ page: value });
      const columnsConfigData = columnsConfig(t);
      const selectedCol = columnsConfigData.find(c => c.field === filterField);
      let filterStr = '';
      if (searchTerm !== '' && selectedCol !== undefined) {
        filterStr = showDateFilter
          ? `${selectedCol.key} eq ${searchTerm}`
          : `${selectedCol.key} eq '${searchTerm}' or substringof('${searchTerm}', ${selectedCol.key}) eq true`;
      }
      if (filterStr !== '') {
        await this.props.getDeliveryTableData(
          skip,
          rowsPerPage,
          this.props.enqueueSnackbar,
          filterStr
        );
      } else {
        await this.props.getDeliveryTableData(skip, rowsPerPage, this.props.enqueueSnackbar);
      }
      window.scrollTo(0, 0);
    } catch (err) {
      console.log(err);
    }
  };

  saveFilterData = async (fData, selectedCol, searchTerm = '') => {
    const { rowsPerPage, showDateFilter } = this.state;
    let filterStr = '';
    if (searchTerm !== '') {
      filterStr = showDateFilter
        ? `${selectedCol.key} eq ${searchTerm}`
        : `${selectedCol.key} eq '${searchTerm}' or substringof('${searchTerm}', ${selectedCol.key}) eq true`;
    }
    if (filterStr !== '') {
      this.props.getDeliveryTableData(0, rowsPerPage, this.props.enqueueSnackbar, filterStr);
      this.setState({ page: 0 });
    }
    this.setState({ filteredData: fData });
  };

  loadDeliveryData = async () => {
    this.setState({ isLoading: true });
    await this.props.getAllDeliveryData(0, this.props.enqueueSnackbar);
    this.setState({ isLoading: false });
  };

  clearFilter = () => {
    const { rowsPerPage } = this.state;
    this.props.getDeliveryTableData(0, rowsPerPage, this.props.enqueueSnackbar);
    this.setState({
      searchTerm: '',
      filterField: '',
      selectedDate: null,
      showDateFilter: false,
      page: 0,
    });
  };

  saveFilterFields = data => {
    this.setState(prevState => ({
      ...prevState,
      ...data,
    }));
  };

  renderDelivery = () => {
    const { delivery, t } = this.props;
    const {
      rowsPerPage,
      page,
      filteredData,
      filterField,
      searchTerm,
      selectedDate,
      showDateFilter,
      isLoading,
    } = this.state;
    const { deliveryDataArr, listCount, failText } = delivery;
    if (deliveryDataArr) {
      return (
        <Table
          columnsConfig={columnsConfig(t)}
          data={deliveryDataArr}
          showExport
          language={this.props.i18n.language}
          rowsPerPage={rowsPerPage}
          listCount={listCount}
          page={page}
          onPageChange={this.handleChange}
          saveFilterData={this.saveFilterData}
          filteredData={filteredData}
          loadFullData={this.loadDeliveryData}
          filterField={filterField}
          searchTerm={searchTerm}
          selectedDate={selectedDate}
          saveFilterFields={this.saveFilterFields}
          clearFilter={this.clearFilter}
          showDateFilter={showDateFilter}
          t={t}
          isLoading={isLoading}
        />
      );
    }
    if (failText !== '') {
      return (
        <Typography sx={styles.failText} textAlign="center">
          {failText}
        </Typography>
      );
    }
    return (
      <Typography sx={styles.failText} textAlign="center">
        {t('deliveryScreenTranslations:NO_DELIVERY_DATA_FOUND')}
      </Typography>
    );
  };

  render() {
    const { delivery, t } = this.props;
    const { isLoading } = delivery;
    return (
      <Container>
        <Breadcrumbs {...this.props} breadcrumbNameMap={breadcrumbNameMap(t)} />
        <ReactPlaceholder
          showLoadingAnimation
          ready={!isLoading}
          customPlaceholder={<DeliveryPlaceholder />}
        >
          <Box sx={styles.tableContainer}>{this.renderDelivery()}</Box>
        </ReactPlaceholder>
      </Container>
    );
  }
}

const mapStateToProps = state => {
  return {
    delivery: state.delivery,
  };
};
const cDelivery = connect(mapStateToProps, { getDeliveryTableData, getAllDeliveryData })(Delivery);
const tDelivery = withTranslation(['deliveryScreenTranslations'])(cDelivery);
const sDelivery = withSnackbar(tDelivery);
export { sDelivery as Delivery };
